import React, { useState } from "react";
import style from "css/landing.module.css";
import { ReactComponent as Arrow } from "asset/common/arrow.svg";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

function TechnologyItem(props) {
  const [isHover, setIsHover] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  return <>
    {
      props.tech.isActive
        ?
        !isMobile && !isTablet ?
          <Link
            to={`${process.env.REACT_APP_CLIENT_URL + props.tech.link}`}
            className={`${style.technology_list_item} ${style[props.type]}`}
            onMouseOver={() => setIsHover(true)}
            onMouseOut={() => setIsHover(false)}
          >
            <div className={style.technology_list_item_text_wrap}>
              <div
                className={style.technology_list_item_label}
                style={{ display: isHover ? "none" : "block" }}
              >
                {props.tech.label}
              </div>
              <div
                className={style.technology_list_item_title}
                dangerouslySetInnerHTML={{ __html: props.tech.title }}
              ></div>
              <div
                className={style.technology_list_item_text}
                style={{ display: isHover ? "block" : "none" }}
              >
                {props.tech.text}
              </div>
            </div>
            <div className={style.technology_list_item_logo_wrap}>
              <div className={style.technology_list_item_link_wrap}>
                <Arrow
                  fill={isHover ? "#0a2cc4" : "none"}
                  width="29px"
                  height="29px"
                />
              </div>
              <div
                className={style.technology_list_item_logo_box}
                style={{
                  backgroundColor: isHover
                    ? props.tech.color
                    : "rgba(255, 255, 255, 0.45)",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}` + props.tech.img}
                  alt="technology_img"
                  className={style.technology_list_item_logo}
                />
              </div>
            </div>
          </Link>
          :
          <Link
            to={props.tech.link}
            className={`${style.technology_list_item} ${style[props.type]}`}
          >
            <div className={style.technology_list_item_text_wrap}>
              <div
                className={style.technology_list_item_label}
                style={{ display: isHover ? "none" : "block" }}
              >
                {props.tech.label}
              </div>
              <div
                className={style.technology_list_item_title}
                dangerouslySetInnerHTML={{ __html: props.tech.title }}
              ></div>
              <div
                className={style.technology_list_item_text}
                style={{ display: isHover ? "block" : "none" }}
              >
                {props.tech.text}
              </div>
            </div>
          </Link>
        :
        isMobile || isTablet
          ? <></>
          :
          <div className={`${style.technology_list_item} ${style[props.type]} ${style.disabled}`}>
            <article className={style.disabled_solution_overlay}>
              <p>곧 공개 예정</p>
              <p>새로운 페이지가 곧 찾아옵니다.</p>
            </article>
            <div className={style.technology_list_item_text_wrap}>
              <div
                className={style.technology_list_item_label}
                style={{ display: isHover ? "none" : "block" }}
              >
                {props.tech.label}
              </div>
              <div
                className={style.technology_list_item_title}
                dangerouslySetInnerHTML={{ __html: props.tech.title }}
              ></div>
              <div
                className={style.technology_list_item_text}
                style={{ display: isHover ? "block" : "none" }}
              >
                {props.tech.text}
              </div>
            </div>
            <div className={style.technology_list_item_logo_wrap}>
              <div className={style.technology_list_item_link_wrap}>
                <Arrow
                  fill={isHover ? "#0a2cc4" : "none"}
                  width="29px"
                  height="29px"
                />
              </div>
              <div
                className={style.technology_list_item_logo_box}
                style={{
                  backgroundColor: isHover
                    ? props.tech.color
                    : "rgba(255, 255, 255, 0.45)",
                }}
              >
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}` + props.tech.img}
                  alt="technology_img"
                  className={style.technology_list_item_logo}
                />
              </div>
            </div>
          </div>
    }

  </>
}

export default TechnologyItem;
